import React from 'react';
import { Link } from 'react-router-dom';
import { TargetIcon, BrainIcon, NetworkIcon, DatabaseIcon, TrendingUpIcon, PlayIcon, BookOpenIcon, ArrowRightIcon } from 'lucide-react';
export function PlatformOverviewPage() {
  return <div className="w-full bg-white" data-id="element-7667">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-red-900 text-white py-24 overflow-hidden" data-id="element-7668">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-7669" />
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-7670">
          <div className="max-w-4xl mx-auto text-center" data-id="element-7671">
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-7672">
              The ZoomInfo GTM Platform
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-7673">
              One platform that connects data, AI, and execution so your GTM
              plays are built once and run everywhere.
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-7674">
              <Link to="/website/platform" className="px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7675">
                View products
              </Link>
              <Link to="/gtm/plays" className="px-8 py-4 bg-white text-gray-900 rounded-lg hover:bg-gray-100 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7676">
                See GTM library
              </Link>
            </div>
            <p className="text-lg text-gray-300" data-id="element-7677">
              Studio plans it. Copilot runs it. Orchestration delivers it. Data
              and Signals fuel it. Predictive points it at the right accounts.
              Plays and Playbooks make it reusable.
            </p>
          </div>
        </div>
      </section>
      {/* 4 Platform Pillars */}
      <section className="py-24 bg-white" data-id="element-7678">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7679">
          <div className="text-center mb-16" data-id="element-7680">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7681">
              Four pillars of the platform
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-7682">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 border-2 border-teal-200 hover:shadow-xl transition-all" data-id="element-7683">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7684">
                <TargetIcon className="w-8 h-8 text-white" data-id="element-7685" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7686">
                Plan in GTM Studio
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7687">
                Build segments, pick a play template, generate assets, and
                publish to every GTM team.
              </p>
              <Link to="/products/gtm-studio" className="inline-flex items-center gap-2 mt-6 text-teal-700 hover:text-teal-800 font-medium" data-id="element-7688">
                Learn more
                <ArrowRightIcon className="w-4 h-4" data-id="element-7689" />
              </Link>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 border-2 border-blue-200 hover:shadow-xl transition-all" data-id="element-7690">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7691">
                <BrainIcon className="w-8 h-8 text-white" data-id="element-7692" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7693">
                Execute with Copilot
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7694">
                Accounts are prioritized. Buying groups are suggested. Outreach
                is generated from context. Reps only adjust and send.
              </p>
              <Link to="/copilot" className="inline-flex items-center gap-2 mt-6 text-blue-700 hover:text-blue-800 font-medium" data-id="element-7695">
                Learn more
                <ArrowRightIcon className="w-4 h-4" data-id="element-7696" />
              </Link>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 border-2 border-purple-200 hover:shadow-xl transition-all" data-id="element-7697">
              <div className="w-16 h-16 bg-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7698">
                <NetworkIcon className="w-8 h-8 text-white" data-id="element-7699" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7700">
                Automate through Orchestration
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7701">
                Turn plays into multi step journeys. Trigger from intent, event,
                web, or product. Route to sales, marketing, CS, or partner.
              </p>
              <Link to="/orchestration" className="inline-flex items-center gap-2 mt-6 text-purple-700 hover:text-purple-800 font-medium" data-id="element-7702">
                Learn more
                <ArrowRightIcon className="w-4 h-4" data-id="element-7703" />
              </Link>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8 border-2 border-orange-200 hover:shadow-xl transition-all" data-id="element-7704">
              <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7705">
                <DatabaseIcon className="w-8 h-8 text-white" data-id="element-7706" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7707">
                Stay accurate with Data, Signals, and Predictive
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7708">
                ZoomInfo data, your CRM, and your product usage come together as
                one GTM signal layer. Predictive ranks what matters now.
              </p>
              <Link to="/data-and-signals" className="inline-flex items-center gap-2 mt-6 text-orange-700 hover:text-orange-800 font-medium" data-id="element-7709">
                Learn more
                <ArrowRightIcon className="w-4 h-4" data-id="element-7710" />
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* GTM Library */}
      <section className="py-24 bg-gray-50" data-id="element-7711">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7712">
          <div className="text-center mb-16" data-id="element-7713">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7714">
              GTM Library inside the platform
            </h2>
            <p className="text-lg text-gray-600" data-id="element-7715">
              The platform ships with GTM knowledge. Not empty screens.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-7716">
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7717">
              <div className="text-3xl font-bold text-red-600 mb-2" data-id="element-7718">15</div>
              <p className="text-gray-900 font-medium" data-id="element-7719">Signal based plays</p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7720">
              <div className="text-3xl font-bold text-red-600 mb-2" data-id="element-7721">12</div>
              <p className="text-gray-900 font-medium" data-id="element-7722">
                Outcome based playbooks
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7723">
              <PlayIcon className="w-8 h-8 text-red-600 mb-2" data-id="element-7724" />
              <p className="text-gray-900 font-medium" data-id="element-7725">
                Expansion and win-back programs
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-red-300 hover:shadow-lg transition-all" data-id="element-7726">
              <BookOpenIcon className="w-8 h-8 text-red-600 mb-2" data-id="element-7727" />
              <p className="text-gray-900 font-medium" data-id="element-7728">
                Event and field programs
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-7729">
            <Link to="/gtm/plays" className="inline-flex items-center gap-2 px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium text-lg" data-id="element-7730">
              Browse plays
              <ArrowRightIcon className="w-5 h-5" data-id="element-7731" />
            </Link>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-red-600 to-red-700 text-white" data-id="element-7732">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7733">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7734">
            Ready to see the platform in action?
          </h2>
          <p className="text-xl text-red-100 mb-8" data-id="element-7735">
            Get a personalized demo of the ZoomInfo GTM Platform
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7736">
            <Link to="/signup" className="px-8 py-4 bg-white text-red-600 rounded-lg hover:bg-red-50 font-medium text-lg shadow-lg" data-id="element-7737">
              Get Started Free
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7738">
              Schedule Demo
            </Link>
          </div>
        </div>
      </section>
    </div>;
}